<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-dark">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">イベント詳細情報</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <!-- 読み込み中: spinner を表示 -->
        <div v-if="isLoading" class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="sr-only">読み込み中...</span>
          </div>
          <p class="mt-3">読み込み中...</p>
        </div>
        <!-- エラー: アラート表示 -->
        <div v-else-if="hasError">
          <base-alert type="warning">
            <span class="alert-inner--icon"><i class="fa fa-question"></i></span>
            <span class="alert-inner--text"><strong>イベント情報無し</strong> イベント情報が見つかりませんでした。URLをお確かめいただくか、再読み込みして下さい。</span>
          </base-alert>
        </div>
        <!-- 成功: イベント情報表示 -->
        <div v-else>
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3">{{ EventInfo.Name }}</h2>
              <h4 v-show="EventInfo.IsPetit == true">（内オンリーイベント「{{ EventInfo.PetitName }}」）</h4>
            </div>
          </div>
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h5>
                  開催日：{{ EventInfo.StartDate }}
                  <span v-show="EventInfo.MultipleDaysEvent == true">～{{ EventInfo.EndDate }}</span>
                </h5>
                <h5>場所：{{ EventInfo.Prefecture }}・{{ EventInfo.Place }}</h5>
                <h6 v-show="EventInfo.Hole">　　　{{ EventInfo.Hole }}</h6>
                <h5>状態：{{ EventInfo.EventStatus }}</h5>
                <div v-if="EventInfo.EventStatus == '参加' || EventInfo.EventStatus == '終了'">
                  <h5>配置：{{ EventInfo.Position }}</h5>
                </div>
                <p v-html="EventInfo.Description"></p>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src="EventInfo.CircleCutUrl" class="img-fluid shadow">
            </div>
          </div>
          <hr>
          <div v-if="EventInfo.MenuUrls">
            <div class="row text-center justify-content-center">
              <div class="col-lg-10">
                <h3 class="display-3">お品書き</h3>
              </div>
            </div>
            <div class="row row-grid align-items-center">
              <div v-for="(item, index) in EventInfo.MenuThumbnailUrls" :key="item.id" class="col-md-4">
                <img :src="item" class="img-fluid shadow" @click="opemImageModal(EventInfo.MenuUrls[index])" style="cursor:pointer">
              </div>
            </div>
            <div>
              <BModal 
                v-model:visible="isImageModalVisible"
                id="image-modal" 
                centered 
                size="lg" 
                no-footer 
                header-class="p-2 border-bottom-0"
              >
                <img :src="ModalImageUrl" class="img-fluid shadow">
              </BModal>
            </div>
            <hr>
          </div>
          <div class="row row-grid align-items-center">
            <div class="col-md-12">
              <div class="btn-wrapper">
                <div v-if="EventInfo.Url">
                  <a :href="EventInfo.Url" target="_blank">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="primary"
                                 icon="ni ni-building">
                      イベントHP
                    </base-button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { useHead } from '@vueuse/head'
import { reactive, onMounted, ref, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import 'moment/locale/ja'
import moment from "moment";

export default {
  name: "eventDetail",
  components: {
    moment
  },
  setup() {
    const route = useRoute()

    const headData = reactive({
      title: 'イベント詳細情報',
      description: '',
      image: location.origin + '/img/brand/default.png',
      card_type: 'summary_large_image'
    })

    const EventInfo = ref(null)
    const ModalImageUrl = ref("")
    const isImageModalVisible = ref(false)
    const isLoading = ref(true)
    const hasError = ref(false)

    // 初期化用の基本的な HEAD タグ
    useHead({
      title: {
        inner: '雛菊書房',
        separator: ' - ',
        complement: 'イベント詳細情報'
      },
      meta: [
        { property: 'og:title', content: '雛菊書房 - イベント詳細情報' },
        { property: 'og:type', content: 'article' },
        { property: 'og:description', content: '' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary_large_image' },
      ]
    })

    // タイトルとOGP情報をDOM に直接設定
    const updateHeadDetails = () => {
      const title = headData.title
      const description = headData.description
      const image = headData.image
      const cardType = headData.card_type

      // ページタイトルを直接設定
      document.title = `雛菊書房 - ${title}`

      // og:title を更新
      let ogTitle = document.querySelector('meta[property="og:title"]')
      if (ogTitle) {
        ogTitle.setAttribute('content', `雛菊書房 - ${title}`)
      }

      // og:description を更新
      let ogDesc = document.querySelector('meta[property="og:description"]')
      if (ogDesc) {
        ogDesc.setAttribute('content', description)
      }

      // og:image を更新
      let ogImage = document.querySelector('meta[property="og:image"]')
      if (ogImage) {
        ogImage.setAttribute('content', image)
      }

      // twitter:card を更新
      let twitterCard = document.querySelector('meta[property="twitter:card"]')
      if (twitterCard) {
        twitterCard.setAttribute('content', cardType)
      }
    }

    const opemImageModal = async (ImageUrl) => {
      ModalImageUrl.value = ImageUrl
      isImageModalVisible.value = false
      await nextTick()
      isImageModalVisible.value = true
    }

    const getEventInfo = (EventId) => {
      isLoading.value = true
      hasError.value = false
      axios.get('/strapi/api/event-informations?populate=%2A&filters[EventId][$eq]=' + EventId)
          .then(response =>{
            if(response.data.data) {
              const eventData = response.data.data[0]
              eventData['StartDate'] = moment(eventData['StartDate']).format('YYYY/MM/DD(ddd)')
              eventData['EndDate'] = moment(eventData['EndDate']).format('YYYY/MM/DD(ddd)')
              if (eventData['StartDate'] != eventData['EndDate']) {
                eventData['MultipleDaysEvent'] = true
              } else {
                eventData['MultipleDaysEvent'] = false
              }
              switch (eventData['EventStatus']){
                case "Announced":
                  eventData['EventStatus'] = "開催告知あり";
                  break;
                case "Planning":
                  eventData['EventStatus'] = "参加予定";
                  break;
                case "Submitted":
                  eventData['EventStatus'] = "申込済み";
                  break;
                case "Listed":
                  eventData['EventStatus'] = "配置発表待ち（当選済）";
                  break;
                case "Placed":
                  eventData['EventStatus'] = "参加";
                  break;
                case "Finished":
                  eventData['EventStatus'] = "終了";
                  break;
                case "Suspended":
                  eventData['EventStatus'] = "中止/延期";
                  break;
                case "Postponed":
                  eventData['EventStatus'] = "延期（延期先発表済）";
                  break;
                case "Cancelled":
                  eventData['EventStatus'] = "中止";
                  break;
                case "Declined":
                  eventData['EventStatus'] = "欠席/配置辞退";
                  break;
                default:
                  break;
              }
              if (eventData['Description']){
                eventData['Description'] = eventData['Description'].replace(/\r?\n/g, '<br >');
              }
              if (eventData.CircleCut){
                eventData['CircleCutUrl'] = '/strapi' + eventData.CircleCut.url
                headData.title = eventData.Name
                headData.description = eventData.Name + ' に関する雛菊書房の参加情報'
                headData.image = location.origin + '/strapi' + eventData.CircleCut.formats.thumbnail.url
              } else {
                headData.title = eventData.Name
                headData.description = eventData.Name + ' に関する雛菊書房の参加情報'
                headData.card_type = 'summary'
              }
              if (eventData.Menu){
                eventData['MenuUrls'] = []
                eventData['MenuThumbnailUrls'] = []
                eventData.Menu.forEach(function (value){
                  eventData['MenuThumbnailUrls'].push('/strapi' + value.formats.medium.url)
                  eventData['MenuUrls'].push('/strapi' + value.url)
                })
              }
              EventInfo.value = eventData
              // API完了後にタイトルとOGP情報を明示的に更新
              updateHeadDetails()
              isLoading.value = false
            } else {
              EventInfo.value = null
              hasError.value = true
              isLoading.value = false
              headData.card_type = 'summary'
            }
          }).catch(error =>{
        console.log(error)
        hasError.value = true
        isLoading.value = false
      })
    }

    onMounted(() => {
      moment.locale('ja')
      isLoading.value = true
      getEventInfo(route.params.id)
    })

    return { EventInfo, ModalImageUrl, isImageModalVisible, isLoading, hasError, opemImageModal }
  }
};
</script>
<style>
</style>
